<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                    'bg-gray-600': sharedService.userTheme === 'dark',
                    'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row items-center">
        <div class="flex flex-row w-full">
          <div>
            <span *ngIf="list.length == 0 && editMode == 'list'">SOA</span>
          </div>
          <div>
            <span *ngIf="list.length > 0 && editMode == 'list'">SOA: {{list.length}} </span>
          </div>
          <div>
            <span *ngIf="editMode == 'add'">Adding SOA</span>
          </div>
        </div>

        <div class="flex flex-row">
          <button mat-icon-button *ngIf="editMode == 'list' && !labService.readonly" matTooltip="Add New SOA Lab" (click)="add()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list' && !labService.readonly && inputLab != null" matTooltip="Save" (click)="save()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">save</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode == 'edit' && !labService.readonly" matTooltip="Delete SOA" (click)="delete()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''" class="text-red-500">delete
            </mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list'" matTooltip="Cancel" (click)="cancel()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">cancel</mat-icon>
          </button>
        </div>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-row" *ngIf="editMode == 'list'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
            'bg-gray-700': sharedService.userTheme === 'dark',
            'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>

        <div class="flex flex-col" *ngIf="list.length > 0 ">

          <div class="flex flex-col" *ngIf="list.length > 0 ">
            <div class="flex flex-row">
              <mat-form-field class="w-1/4">
                <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
                  value="{{listFilter}}" />

                <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div style="overflow-x:auto">
              <div class="flex flex-row">
                <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort 
                  #TableSort="matSort" class="mat-elevation-z8 w-full" matSortActive="labName" matSortDirection="desc">
                  <ng-container matColumnDef="labName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                    <td mat-cell *matCellDef="let change">{{change.labName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="stateNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>State Number</th>
                    <td mat-cell *matCellDef="let change">{{change.stateNumber}}</td>
                  </ng-container>
                  <ng-container matColumnDef="comments">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Comments</th>
                    <td mat-cell *matCellDef="let change">{{change.comments}}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="rowclick(row)"></tr>
                </table>
              </div>
            </div>
            <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
            </mat-paginator>
          </div>
        </div>

      </mat-card-content>

    </mat-card>
  </div>

  <div class="flex flex-row" *ngIf="editMode !== 'list'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
            'bg-gray-700': sharedService.userTheme === 'dark',
            'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row flex-wrap w-1/2 sm:flex-col">
        <mat-card-content class="w-full gap-4">
          <div class="flex flex-col mt-4">
            <div class="flex flex-col" *ngIf="editMode == 'add'">
              <mat-form-field class="flex-1 min-w-[300px] sm:min-w-full" Style="padding-right:20px">
                <input matInput placeholder="SEARCH: {{label}}" [(ngModel)]="search" (keyup.enter)="getSoaList()" />
                <button *ngIf="search" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <div>
                <button type="button" mat-raised-button color="primary" (click)="getSoaList()">Search</button>
              </div>
            </div>
            <div class="flex flex-col" *ngIf="soaList.length > 0 || editMode == 'edit'">
              <mat-form-field *ngIf="editMode == 'add'">
                <mat-label>SELECT: SOA Lab Name</mat-label>
                <mat-select [(ngModel)]='selectedSoa' (selectionChange)="updateFields($event.value)">
                  <mat-option *ngFor="let soa of soaList" [value]="soa">{{soa.labName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field *ngIf="editMode == 'edit'">
                <mat-label>Select SOA Lab Name</mat-label>
                <input matInput [(ngModel)]="inputLabName" [readonly]="true">
              </mat-form-field>
              <mat-form-field>
                <mat-label>SOA State Number</mat-label>
                <input matInput [(ngModel)]="inputStateNumber" [readonly]="true">
              </mat-form-field>

              <mat-form-field>
                <mat-label>Comments</mat-label>
                <textarea matInput cdkTextareaAutosize [(ngModel)]='inputComments'></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </div>
    </mat-card>
  </div>

</div>
